/**
 * Card de progresso da análise de conversas na edição da pipeline.
 */
Eloca.behaviors.pipelineAnaliseProgresso = function (context) {
    const $card = $(".js-pipeline-analise-progresso", context);
    if (!$card.length) {
        return;
    }

    const statusUrl = $card.attr("data-status-url");
    if (!statusUrl) {
        return;
    }

    const $barra = $card.find(".js-pipeline-analise-barra");
    const $contagem = $card.find(".js-pipeline-analise-contagem");
    const $estado = $card.find(".js-pipeline-analise-estado");
    const $consumoTotal = $card.find(".js-pipeline-analise-consumo-total");
    const $consumoDetalhe = $card.find(".js-pipeline-analise-consumo-detalhe");
    const $vazio = $card.find(".js-pipeline-analise-vazio");
    const $pendentesBloco = $card.find(".js-pipeline-analise-pendentes-bloco");
    const $pendentesLista = $card.find(".js-pipeline-analise-pendentes");
    const $analisesBloco = $card.find(".js-pipeline-analise-analises-bloco");
    const $analisesLista = $card.find(".js-pipeline-analise-analises");
    const $toggle = $card.find(".js-pipeline-analise-ativa");
    const $detalhe = $card.find(".js-pipeline-analise-detalhe");
    const intervaloMs = 5000;
    let emVoo = false;

    const renderItem = function (item, pendente) {
        const $li = $('<li class="pipeline-analise-progresso__item"></li>');
        const $topo = $('<div class="pipeline-analise-progresso__item-topo"></div>');
        const titulo = "#" + (item.oportunidade_id || "") + " " + (item.nome || "");
        $topo.append($("<strong></strong>").text(titulo));
        const meta = pendente
            ? "Pendente"
            : (item.qualidade_rotulo || "") + (item.quando ? " · " + item.quando : "");
        $topo.append($("<span></span>").text(meta));
        $li.append($topo);
        if (!pendente && item.sinais) {
            $li.append(
                $('<p class="pipeline-analise-progresso__item-sinais"></p>').text(item.sinais)
            );
        }
        if (!pendente && item.resumo) {
            $li.append(
                $('<p class="pipeline-analise-progresso__item-resumo"></p>').text(item.resumo)
            );
        }
        return $li;
    };

    const renderLista = function ($bloco, $lista, itens, pendente) {
        $lista.empty();
        if (!itens || !itens.length) {
            $bloco.addClass("d-none");
            return;
        }
        $bloco.removeClass("d-none");
        itens.forEach(function (item) {
            $lista.append(renderItem(item, pendente));
        });
    };

    const aplicar = function (dados) {
        if (!dados) {
            return;
        }

        const processando = !!dados.processando;
        $barra.toggleClass("is-processando", processando);
        $barra.css("width", (dados.largura_barra || 0) + "%");
        $barra.attr("aria-valuenow", Math.round(dados.cobertura || 0));
        $contagem.text(dados.texto_contagem || "");
        $estado.text(dados.texto_estado || "");
        $consumoTotal.text(dados.texto_consumo_total || "");
        $consumoDetalhe.text(dados.texto_consumo_detalhe || "");

        if (dados.mensagem_vazia) {
            $vazio.text(dados.mensagem_vazia).removeClass("d-none");
        } else {
            $vazio.addClass("d-none");
        }

        renderLista($pendentesBloco, $pendentesLista, dados.pendentes_itens || [], true);
        renderLista($analisesBloco, $analisesLista, dados.analises || [], false);
    };

    const buscar = function () {
        if (emVoo || !analiseAtiva()) {
            return;
        }
        emVoo = true;
        $.getJSON(statusUrl)
            .done(aplicar)
            .always(function () {
                emVoo = false;
            });
    };

    const analiseAtiva = function () {
        return !$toggle.length || $toggle.is(":checked");
    };

    const atualizarVisibilidade = function () {
        $detalhe.toggleClass("is-fechado", !analiseAtiva());
    };

    const iniciarPoll = function () {
        if ($card.data("pipeline-analise-poll")) {
            return;
        }
        $card.data("pipeline-analise-poll", setInterval(buscar, intervaloMs));
    };

    $toggle.off("change.pipelineAnalise").on("change.pipelineAnalise", function () {
        atualizarVisibilidade();
        if (analiseAtiva()) {
            iniciarPoll();
            buscar();
        }
    });
    atualizarVisibilidade();

    if (analiseAtiva()) {
        iniciarPoll();
    }
};
